import { ChangeDetectionStrategy, Component, OnInit, inject, signal, effect, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-fast-search',
  templateUrl: './fast-search.component.html',
  styleUrls: ['./fast-search.component.less'],
  standalone: true,
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FastSearchComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected readonly searchText = signal<string>('');
  protected readonly keyUp$ = new Subject<Event>();
  protected focused = false;

  private readonly DEBOUNCE_TIME = 200;
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    // Следим за изменениями параметров route
    effect(() => {
      this.route.queryParams
        .pipe(
          map(params => params['text'] || ''),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(text => {
          if (text !== this.searchText()) {
            this.searchText.set(text);
          }
        });
    });
  }

  ngOnInit(): void {
    this.initializeSearchSubscription();
  }

  private initializeSearchSubscription(): void {
    this.keyUp$
      .pipe(
        map((event: Event) => (event.target as HTMLInputElement).value),
        debounceTime(this.DEBOUNCE_TIME),
        distinctUntilChanged()
      )
      .subscribe(searchValue => {
        this.updateRouteWithSearch(searchValue);
      });
  }

  protected onSearchChange(value: string): void {
    this.searchText.set(value);
    this.updateRouteWithSearch(value);
  }

  private updateRouteWithSearch(searchValue: string): void {
    this.router.navigate([], {
      queryParams: { text: searchValue || null },
      queryParamsHandling: 'merge',
    });
  }
}
